import type { ButtonHTMLAttributes } from 'react';

import './slider-button.css';

export type SliderButtonDirection = 'left' | 'right';
export type SliderButtonState = 'Default' | 'disabled';

type SliderButtonNativeProps = Omit<
  ButtonHTMLAttributes<HTMLButtonElement>,
  'children' | 'disabled' | 'style' | 'type'
>;

export interface SliderButtonProps extends SliderButtonNativeProps {
  direction: SliderButtonDirection;
  state: SliderButtonState;
  'aria-label': string;
}

const FIGMA_NODE: Record<SliderButtonDirection, Record<SliderButtonState, string>> = {
  right: {
    Default: '90:30857',
    disabled: '90:30872',
  },
  left: {
    Default: '90:30874',
    disabled: '90:30862',
  },
};

export function SliderButton({
  direction,
  state,
  className = '',
  ...props
}: SliderButtonProps) {
  const classes = [
    'lovo-slider-button',
    `lovo-slider-button--${direction}`,
    `lovo-slider-button--${state.toLowerCase()}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');
  const isDisabled = state === 'disabled';

  return (
    <button
      {...props}
      aria-disabled={isDisabled}
      className={classes}
      data-figma-node={FIGMA_NODE[direction][state]}
      data-figma-variant={`Direction=${direction}, State=${state}`}
      disabled={isDisabled}
      type="button"
    >
      <span className="lovo-slider-button__arrow" aria-hidden="true" />
    </button>
  );
}
